import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';

import { isValidJobPosition } from './isValidJobPosition';

export const getFirstValidJobPosition = (
  positions?: OrganizationJobPosition[],
): OrganizationJobPosition | null => {
  return positions?.find(isValidJobPosition) ?? null;
};
